<template>
  <section id="experience" class="experience">
    <div class="experience-container">
      <div class="section-header">
        <h2 class="section-title">Experience</h2>
        <p class="section-subtitle">My professional journey</p>
      </div>
      
      <div class="experience-content">
        <div class="timeline">
          <div class="experience-item" v-for="job in experiences" :key="job.id">
            <div class="timeline-marker"></div>
            <div class="experience-card">
              <div class="company-logo">
                <div class="logo-placeholder">
                  <i :class="job.icon"></i>
                </div>
              </div>
              
              <div class="experience-details">
                <h3 class="job-title">{{ job.title }}</h3>
                <h4 class="company-name">{{ job.company }}</h4>
                <p class="job-duration">{{ job.duration }}</p>
                <p class="job-location">{{ job.location }}</p>
                
                <div class="job-skills">
                  <span class="skill-tag" v-for="skill in job.skills" :key="skill">
                    {{ skill }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ExperienceSection',
  data() {
    return {
      experiences: [
        {
          id: 1,
          title: 'Software Developer',
          company: 'TintBytes.com',
          duration: 'Feb 2025 - Present · 7 mos',
          location: 'Goa, India · Remote',
          type: 'Full-time',
          skills: ['Laravel', 'Vue.js'],
          icon: 'fas fa-code'
        },
        {
          id: 2,
          title: 'Software Developer',
          company: 'Bizinso',
          duration: 'Aug 2023 - Nov 2024 · 1 yr 4 mos',
          location: 'Mumbai, Maharashtra, India · On-site',
          type: 'Full-time',
          skills: ['Software Development', 'HTML', 'JavaScript', 'PHP'],
          icon: 'fas fa-laptop-code'
        },
        {
          id: 3,
          title: 'PHP Developer',
          company: 'CapriTech Global Services Pvt. Ltd.',
          duration: 'Jun 2021 - Aug 2023 · 2 yrs 3 mos',
          location: 'Mumbai, Maharashtra, India · On-site',
          type: 'Full-time',
          skills: ['PHP', 'Software Development', 'HTML', 'MySQL'],
          icon: 'fab fa-php'
        }
      ]
    }
  }
}
</script>

<style scoped>
.experience {
  padding: 5rem 0;
  background: white;
}

.experience-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.section-header {
  text-align: center;
  margin-bottom: 4rem;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 1rem;
}

.section-subtitle {
  font-size: 1.1rem;
  color: #7f8c8d;
  max-width: 600px;
  margin: 0 auto;
}

.experience-content {
  max-width: 800px;
  margin: 0 auto;
}

.timeline {
  position: relative;
  padding-left: 2rem;
}

.timeline::before {
  content: '';
  position: absolute;
  left: 1rem;
  top: 0;
  bottom: 0;
  width: 2px;
  background: linear-gradient(180deg, #3498db, #2ecc71);
}

.experience-item {
  position: relative;
  margin-bottom: 3rem;
}

.timeline-marker {
  position: absolute;
  left: -2rem;
  top: 1.5rem;
  width: 12px;
  height: 12px;
  background: #3498db;
  border-radius: 50%;
  border: 3px solid white;
  box-shadow: 0 0 0 3px #3498db;
  z-index: 2;
}

.experience-card {
  background: #f8f9fa;
  border-radius: 15px;
  padding: 2rem;
  margin-left: 2rem;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-left: 4px solid #3498db;
}

.experience-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 40px rgba(0,0,0,0.15);
}

.company-logo {
  position: absolute;
  top: -15px;
  right: 2rem;
  width: 50px;
  height: 50px;
}

.logo-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #3498db, #2ecc71);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.5rem;
  box-shadow: 0 5px 15px rgba(52, 152, 219, 0.3);
}

.experience-details {
  padding-right: 4rem;
}

.job-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 0.5rem;
}

.company-name {
  font-size: 1.1rem;
  font-weight: 600;
  color: #3498db;
  margin-bottom: 0.8rem;
}

.job-duration {
  font-size: 0.95rem;
  color: #555;
  margin-bottom: 0.3rem;
  font-weight: 500;
}

.job-location {
  font-size: 0.9rem;
  color: #7f8c8d;
  margin-bottom: 1.5rem;
}

.job-skills {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.skill-tag {
  background: white;
  color: #2c3e50;
  padding: 0.4rem 0.8rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 500;
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
}

.skill-tag:hover {
  background: #3498db;
  color: white;
  border-color: #3498db;
}

/* Responsive */
@media (max-width: 768px) {
  .timeline {
    padding-left: 1rem;
  }
  
  .timeline::before {
    left: 0.5rem;
  }
  
  .timeline-marker {
    left: -1.5rem;
  }
  
  .experience-card {
    margin-left: 1rem;
    padding: 1.5rem;
  }
  
  .company-logo {
    position: static;
    margin-bottom: 1rem;
    width: 40px;
    height: 40px;
  }
  
  .experience-details {
    padding-right: 0;
  }
  
  .job-title {
    font-size: 1.2rem;
  }
  
  .section-title {
    font-size: 2rem;
  }
  
  .job-skills {
    margin-top: 1rem;
  }
}
</style>
